export default {
  root: {
    padding: "16px",
    paddingBottom: "16px",
    "&:last-child": { paddingBottom: "16px" }
  }
};
